module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Clothes/Hat-98d6412a7e4a13c6a43518abc7a1fbc933b9333945e9a4e2431771c3feaed97b.svg";